var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99967 12.5L12.4997 9.99998M12.4997 9.99998L9.99967 7.49998M12.4997 9.99998H3.33301M3.33301 6.04V6.00015C3.33301 5.06672 3.33301 4.59966 3.51467 4.24315C3.67445 3.92954 3.92923 3.67475 4.24284 3.51497C4.59936 3.33331 5.06642 3.33331 5.99984 3.33331H13.9998C14.9333 3.33331 15.3993 3.33331 15.7558 3.51497C16.0694 3.67475 16.3251 3.92954 16.4848 4.24315C16.6663 4.59931 16.6663 5.0658 16.6663 5.9974V14.003C16.6663 14.9346 16.6663 15.4004 16.4848 15.7566C16.3251 16.0701 16.0694 16.3254 15.7558 16.4851C15.3997 16.6666 14.9338 16.6666 14.0023 16.6666H5.9971C5.0655 16.6666 4.59901 16.6666 4.24284 16.4851C3.92923 16.3254 3.67445 16.0699 3.51467 15.7563C3.33301 15.3998 3.33301 14.9334 3.33301 14V13.9583",
    stroke: "#6130B5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.6aec70ebbef9c3de350b7d75a6d840fc.svg";
export { ForwardRef as ReactComponent };